'use client';
import { SPACING_1, SPACING_3, WEB_PURPLE_REG } from '@mnd-frontend/ui/shared/tokens';
import type { ColorPropType } from '@mnd-frontend/ui/shared/types/color';
import styled from 'styled-components';

const Styling = styled.div<{ $color?: ColorPropType | 'inherit' }>`
  //@todo web/body/reg
  display: grid;
  gap: 1.25rem;
  color: ${({ $color }) => ($color ? $color : WEB_PURPLE_REG)};
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  ul,
  ol {
    margin: 0;
    padding-left: ${SPACING_3};

    li + li {
      margin-top: ${SPACING_1};
    }
  }

  strong {
    font-weight: 600;
  }
`;

const Wysiwyg = ({
  htmlContent,
  color,
}: {
  htmlContent: string | TrustedHTML | null | undefined;
  color?: ColorPropType | 'inherit';
}) => <Styling $color={color} dangerouslySetInnerHTML={{ __html: htmlContent ?? '' }} />;

export default Wysiwyg;
